import type { Page } from "../types.js";

/**
 * Pages that act on the signed-in user's own content (create, generation
 * status, editor, My Novels). Browsing and playing stay public.
 */
const OWNER_ONLY_PAGES: ReadonlySet<Page> = new Set(["create", "status", "editor", "profile"]);

export function isOwnerOnlyPage(page: Page): boolean {
  return OWNER_ONLY_PAGES.has(page);
}

/**
 * When auth is configured, owner-only pages require a signed-in user — the app
 * shows the sign-in screen instead. Returns true when the page should be
 * blocked behind sign-in.
 *
 * - Auth not configured (local MVP): never blocks; the app acts as `local_user`.
 * - Session still resolving: never blocks, to avoid flashing the sign-in screen
 *   before a restored session loads.
 */
export function isOwnerPageBlocked(
  page: Page,
  options: { authEnabled: boolean; signedIn: boolean; sessionLoading: boolean }
): boolean {
  if (!options.authEnabled) return false;
  if (options.sessionLoading) return false;
  if (options.signedIn) return false;
  return isOwnerOnlyPage(page);
}
